import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { CheckActions } from 'actions'
import CheckDetailSource from '../sources/CheckDetailSource'
import { Analytics } from 'common-frontend'
import { API_BASE } from 'consts'

@createActions(alt)
export default class CheckDetailActions {
  constructor() {
    this.generateActions(
      'fetching',
      'fetched'
    )
  }

  fetch({ id, refresh }) {
    this.fetching(null)

    return CheckDetailSource.get({ id, refresh })
      .then(({id, result, refresh}) => {
        this.fetched(result)
        CheckActions.updateCheckStatus({
          typeId: id,
          verdict: result.verdict,
          verdictFriendly: result.verdictFriendly,
          executeResult: result.executeResult,
          exception: result.exception
        })

        if (refresh) {
          Analytics.track('Re-check this page', {
            advisorType: result.type
          })
        }
        Analytics.track('Viewed check detail', {
          advisorType: result.type,
          verdict: result.verdict
        })
      })
  }

  fetchAdhoc(typeId, url) {
    this.fetching(url)

    return CheckDetailSource.getAdhoc(typeId, url)
      .then(result => {
        Analytics.track('Check a different URL', {
          advisorType: result.type,
          url: url
        })
        this.fetched(result)
      })
  }
}



// WEBPACK FOOTER //
// ./app/actions/CheckDetailActions.js